export const flashCardsLoading =  ({store})  => store.flashCardsReducer.loading;

export const flashCardsError =  ({store})  => store.flashCardsReducer.error;

export const flashCardsData =  ({store})  => store.flashCardsReducer.data;